import React from "react";
import FormActions from "../FormAction/FormActions";
import { RequestServiceActions } from "services/services-mia/RequestServiceActions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { modalData, snackbarData, userCredentials } from "recoilState/GlobalState";
import { ACTIONS } from "consts/Actions";

export default function InsertModal({ updateList }) {
    const credentials = useRecoilValue(userCredentials);
    const setModalDetails = useSetRecoilState(modalData)
    const setSnackbarInfo = useSetRecoilState(snackbarData)
    const handleSubmit = async (values) => {
        try {
            const body = {
                service: "SBMDocumentoIns",
                params: {
                    sbmTipoDocumentoId: values.tipoDocumento,
                    sbmDocumentoFecha: values.fechaDocumento,
                    sbmDocumentoNombre: values.nombreDocumento,
                    sbmDocumentoDescripcion: values.descripcion,
                    sbmDocumentoRequiereFirma: values.requiereFirma === true ? "Y" : "N",
                    sbmDocumentoFirmantesExternos: values.cantFirmantesExternos,
                    sbmDocumentoFirmantesInternos: values.cantFirmantesInternos,
                    sbmDocumentoIdExterna: values.idExterna,
                    sbmDocumentoReferencia: values.referencia,
                    sbmDocumentoGrupo: values.grupo,
                    sbmDocumentoTipoFirma: values.tipoFirma,
                }

            }
            await RequestServiceActions(body, credentials, ACTIONS.INSERT, setSnackbarInfo);
            setModalDetails({ isOpen: false });
            updateList();
        } catch (e) {

        }
    }
    return (
        <section>
            <main>
                <FormActions handleSubmit={handleSubmit} initialValues={{
                    tipoDocumento: null,
                    tipoFirma: "D",
                    cantFirmantesExternos: 1,
                    cantFirmantesInternos: 0,
                    nombreDocumento: "",
                    descripcion: "",
                    fechaDocumento: new Date().toISOString().split('T')[0],
                    idExterna: "",
                    referencia: "",
                    grupo: "",
                }} />
            </main>
        </section>
    );
}